var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"app-screenshot"},[(_vm.showSkeleton)?_c('div',{staticClass:"app-screenshot__image app-screenshot__image--portrait app-screenshot-skeleton"},[_c('t-skeleton-loader',{attrs:{"type":"rectangle","width":"inherit","height":"100%"}})],1):_vm._e(),_vm._v(" "),(_vm.url)?_c('img',{staticClass:"app-screenshot__image",class:{
            [`app-screenshot__image--${_vm.orientation}`]: true,
            'app-screenshot__image--loading': !_vm.isLoaded,
        },attrs:{"loading":"lazy","decoding":"async","src":_vm.src},on:{"load":_vm.checkOrientation}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }